// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IbIj","content":"styles_content__O8_5o","row":"styles_row__PIUbs","footer":"styles_footer__3t3S1","phraseLength":"styles_phraseLength__2_Qup"};